const DownloadBook = ({ setActiveTab, data }: any) => {
  const { ecompinfo } = data;
  const { sasUrl, name, size } = ecompinfo

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = name;
    link.target = "_blank"; // prevents same-tab navigation
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFileType = (fileName: any) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'txt':
        return 'text/plain';
      case 'zip':
        return 'application/zip';
      default:
        return 'unknown';
    }
  };


  return (
    <div className="download-book-container">
      {/* Header */}
      <p className="alert-text">
        <b>Please read before you download your Book:</b>
      </p>

      {/* Author Help Section */}
      <div className="author-help">
        <p className="author-help_heading"><b>General Author Help</b></p>
        <p>
          Visit{" "}
          <a
            href="http://www.elsevier.com/authors/book-authors"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://www.elsevier.com/authors/book-authors
          </a>
        </p>
      </div>

      {/* Notice Section */}
      <p className="notice">
        <span className="circle-number">1</span> <b>This will be available for a limited period of time. Please download it promptly.</b>
      </p>

      {/* Download Section */}
      <p className="download-instruction">
        <span className="icon"><img src="downloadicon.png" alt="download icon" /></span> <b>Download your Book by clicking on the file name listed below</b>
      </p>

      {/* Table */}
      <table className="book-table">
        <thead>
          <tr>
            <th>File name</th>
            <th>File type</th>
            <th>File size</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span onClick={handleDownload} style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}>
                {name}
              </span>
            </td>
            <td>{getFileType(name)}</td>
            <td>{(size / 1024).toFixed(2)} KB</td>
          </tr>
        </tbody>
      </table>

      <div className="button-group">
        <button className="back-button" onClick={() => setActiveTab('adobe')}>BACK</button>

      </div>

    </div>
  );
};

export default DownloadBook;
